// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("date-fns");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
var AgentPropertyMlsStatus_mlsPlan_graphql = require("../../../__generated__/AgentPropertyMlsStatus_mlsPlan_graphql.bs.js");
var AgentPropertyMlsStatus_property_graphql = require("../../../__generated__/AgentPropertyMlsStatus_property_graphql.bs.js");

var convertFragment = AgentPropertyMlsStatus_mlsPlan_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentPropertyMlsStatus_mlsPlan_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentPropertyMlsStatus_mlsPlan_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentPropertyMlsStatus_mlsPlan_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentPropertyMlsStatus_mlsPlan_graphql.node, convertFragment, fRef);
}

var MlsPlanFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = AgentPropertyMlsStatus_property_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentPropertyMlsStatus_property_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentPropertyMlsStatus_property_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentPropertyMlsStatus_property_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AgentPropertyMlsStatus_property_graphql.node, convertFragment$1, fRef);
}

var PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function formatCalendarDate(calendarDate) {
  return DateFns.format(CalendarDate.toLocalDate(calendarDate), "MMMM d");
}

function AgentPropertyMlsStatus$MlsStatus(props) {
  var __size = props.size;
  var detailText = props.detailText;
  var size = __size !== undefined ? __size : "md";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Icon__Jsx3.make, {
                      icon: "Calendar",
                      size: 20
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: props.status,
                              className: "font-medium"
                            }),
                        detailText !== undefined ? JsxRuntime.jsx("span", {
                                children: " " + detailText,
                                className: "text-gray-500"
                              }) : null
                      ],
                      className: "text-gray-700 " + (
                        size === "sm" ? "text-base" : "text-lg"
                      )
                    })
              ],
              className: "flex flex-row items-center gap-2"
            });
}

var MlsStatus = {
  make: AgentPropertyMlsStatus$MlsStatus
};

function AgentPropertyMlsStatus$FromMlsPlan(props) {
  var size = props.size;
  var activeOnMlsSince = props.activeOnMlsSince;
  var mlsPlan = use(props.mlsPlan);
  if (activeOnMlsSince !== undefined) {
    return JsxRuntime.jsx(AgentPropertyMlsStatus$MlsStatus, {
                status: "On-MLS",
                detailText: "since " + formatCalendarDate(Caml_option.valFromOption(activeOnMlsSince)),
                size: size
              });
  }
  switch (mlsPlan.__typename) {
    case "AlreadyOnMls" :
        return null;
    case "ListOnMlsAsActive" :
        return JsxRuntime.jsx(AgentPropertyMlsStatus$MlsStatus, {
                    status: "Off-MLS",
                    detailText: "until " + formatCalendarDate(mlsPlan.onMlsAt),
                    size: size
                  });
    case "ListOnMlsAsComingSoon" :
        return JsxRuntime.jsx(AgentPropertyMlsStatus$MlsStatus, {
                    status: "MLS Coming Soon",
                    detailText: "going active on " + formatCalendarDate(mlsPlan.activeOnMlsOn),
                    size: size
                  });
    case "NoMlsPlan" :
        return JsxRuntime.jsx(AgentPropertyMlsStatus$MlsStatus, {
                    status: "Off-MLS",
                    size: size
                  });
    case "__unselected" :
        return UnselectedUnionMemberError.raise("Unselected mls status " + mlsPlan._0);
    
  }
}

var FromMlsPlan = {
  make: AgentPropertyMlsStatus$FromMlsPlan
};

function AgentPropertyMlsStatus$WithoutErrorBoundary(props) {
  var property = use$1(props.property);
  return JsxRuntime.jsx(AgentPropertyMlsStatus$FromMlsPlan, {
              mlsPlan: property.mlsPlan.fragmentRefs,
              activeOnMlsSince: property.activeOnMlsSince,
              size: props.size
            });
}

var WithoutErrorBoundary = {
  make: AgentPropertyMlsStatus$WithoutErrorBoundary
};

function AgentPropertyMlsStatus(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "MLS status",
              children: JsxRuntime.jsx(AgentPropertyMlsStatus$WithoutErrorBoundary, {
                    property: props.property,
                    size: props.size
                  })
            });
}

var make = AgentPropertyMlsStatus;

exports.MlsPlanFragment = MlsPlanFragment;
exports.PropertyFragment = PropertyFragment;
exports.formatCalendarDate = formatCalendarDate;
exports.MlsStatus = MlsStatus;
exports.FromMlsPlan = FromMlsPlan;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* date-fns Not a pure module */
